function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "dashboard-arrow");

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#1b75bc",
  points: "14.57 18.64 29.14 0 0 0 14.57 18.64"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.14,
    height: 18.64,
    viewBox: "0 0 29.14 18.64"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/dashboard-arrow.f2a40580.svg";
export { SvgComponent as ReactComponent };